import { useContext, useEffect, useRef, useState } from "react"
import { ILocal, IRegistros, IVaga } from "../../@interfaces"
import APIPonto from "../../services/APIPonto"
import { Container, Dropdown, EntryCell, EntryItem, FetchButton, DateInput, SearchContainer, SectionContainer, SectionHeader, SettingsContainer } from "./styles"
import { BsChevronCompactDown } from "react-icons/bs"
import { AiOutlineSearch } from "react-icons/ai"
import Loading from '../../components/loading'
import { SelectOptions } from "../../@types"
import ToastContext from "../../contexts/toast"
import aux from "../../utils/auxiliar"
import { CustumerContext } from "../../contexts/custumer"
import Options from "../../components/select/options"
import EmptyListMessage from "../../components/mensagemlistavazia"
import moment from "moment"
import { Botao } from "../../components/botaofiltrar/styles"
import BotaoFiltrar from "../../components/botaofiltrar"
import Subtitle from "../../components/subtitle"
import Text from "../../components/text"
import Title from "../../components/title"
import Input from "../../components/input"
import CardRegistroMobile from "./components/cardpontomobile"
import { IoChevronDown } from "react-icons/io5"
import useIsMobile from "../../hooks/useIsMobile"

const Ponto: React.FC = () => {
	const [placeList, setPlaceList] = useState<SelectOptions[]>();
	const [data, setData] = useState<IVaga[]>();
	const [selectedPlace, setSelectedPlace] = useState<number | string>();
	const [selectedDate, setSelectedDate] = useState<string>(moment().subtract(1, 'd').format('YYYY-MM-DD'));
	const [isPlaceOptionsOpen, setPlaceOptionsOpen] = useState<boolean>(false);

	const [search, setSearch] = useState<string>();
	const [isListLoading, setIsListLoading] = useState<boolean>(false);
	const [isPlacesLoading, setIsPlacesLoading] = useState<boolean>(false);

	const { showErrorToast } = useContext(ToastContext);
	const { id_current_custumer } = useContext(CustumerContext);
	const isMobile = useIsMobile();


	useEffect(() => {
		loadPlaces();
		setData(undefined);
		setSelectedPlace("");
	}, [id_current_custumer]);



	async function loadPlaces() {
		try {
			setIsPlacesLoading(true);
			const body = {
				cliente: id_current_custumer,
				SomentePontoEletronico: true
			}

			const response = await APIPonto.getPlacesList(body);



			if (!response.error) {
				const formattedOptions = formatOptions(response.local!);
				setPlaceList(formattedOptions);

				if (formatOptions.length > 0) {
					const firstPlace = formattedOptions[0].value;
					setSelectedPlace(firstPlace);
					loadData(firstPlace, selectedDate);
				}

			} else {
				showErrorToast(response.message);
				setPlaceList([]);
			}
		} catch {
			showErrorToast("Algo deu errado.");
		} finally {
			setIsPlacesLoading(false);
		}
	}




	async function loadData(customPlace?: number, customDate?: string) {
		try {
			setIsListLoading(true);

			let body: any = {
				local: '',
				dataPonto: ''
			};

			if (!customPlace || !customDate) {
				body = {
					local: selectedPlace!,
					dataPonto: aux.formatDateToString(selectedDate!)
				}
			} else {
				body = {
					local: customPlace!,
					dataPonto: aux.formatDateToString(customDate!)
				}
			}

			const response = await APIPonto.getPontoList(body);
			if (!response.error) {
				setData(response.vaga)
			} else {
				setData([])
				showErrorToast(response.message)
			}

		} catch (e) {
			console.log(e)
			showErrorToast('Algo deu errado');
		} finally {
			setIsListLoading(false);
		}
	}




	function formatOptions(list: ILocal[]) {
		const newArray = list.map(item => {
			return {
				value: item.local,
				label: item.descricao
			}
		})

		return newArray;
	}




	function handleDateChange(value: string) {
		setSelectedDate(value);
	}




	function openPlaceOptions() {
		setPlaceOptionsOpen(true);
	}




	function closePlaceOptions() {
		setPlaceOptionsOpen(false);
	}




	function handleSelectPlace(value: number | string) {
		console.log(value)
		console.log()
		setSelectedPlace(value);
		closePlaceOptions();
	}



	function handleSearch(value: string) {
		setSearch(value.toUpperCase());
	}



	let entriesToShow: IRegistros[][] = [];

	if (data) {
		for (let i of data!) {
			const aux = !!search ?
				i.registroMarcacao.filter(item => item.nome.toUpperCase().includes(search) || String(item.rE).toUpperCase().includes(search))
				: i.registroMarcacao;

			entriesToShow.push(aux);
		}
	}

	const showNoPlaceMessage = placeList?.length === 0 && !isPlacesLoading;
	const showNoDataMessage = data?.length === 0 && !isListLoading && !showNoPlaceMessage;

	return (
		<Container>

			{isPlaceOptionsOpen &&
				<Options
					close={closePlaceOptions}
					selectOption={handleSelectPlace}
					itens={placeList}
					sortAlphabetically
				/>

			}

			{placeList && placeList?.length > 0 && !isPlacesLoading &&
				<SettingsContainer>
					<div className="!gap-[50px] flex items-center max-[660px]:justify-between max-[580px]:w-full max-[580px]:!gap-4  max-[475px]:!gap-[25px]">
						<div className="flex max-[475px]:flex-col max-[475px]:items-start max-[475px]:gap-1 items-center gap-3 max-[580px]:w-full">
							<Subtitle className='!text-[.875rem]'>
								Local
							</Subtitle>
							<Dropdown onClick={openPlaceOptions} className="!h-[32.800px]">
								<Text className="!overflow-ellipsis !font-normal !overflow-hidden !whitespace-nowrap !text-[rgba(0,0,0,.5)]">{placeList!.find(item => item.value === selectedPlace)?.label || 'selecione o local'}</Text>
								<IoChevronDown size={12} />
							</Dropdown>
						</div>

						<div className="flex max-[475px]:flex-col max-[475px]:items-start max-[475px]:gap-1 items-center gap-3 max-[580px]:w-full">
							<Subtitle className='!text-[.875rem]'>
								Data
							</Subtitle>

							<div className="relative max-[580px]:w-full">
								<DateInput type={'date'} value={selectedDate} onChange={e => handleDateChange(e.target.value)} max={aux.getToday()} id="date_input" />
								{isMobile && <IoChevronDown size={12} className="text-[rgba(0,0,0,0.5)] absolute right-[6px] top-[50%] translate-y-[-50%] pointer-events-none" />}
							</div>
						</div>
					</div>

					<div className="w-full flex !gap-[50px] justify-between">
						{selectedDate && selectedPlace && <div>
							<BotaoFiltrar onClick={() => loadData(undefined, undefined)} disabled={isListLoading || isPlacesLoading} />

						</div>}

						{data && data.length > 0 && <Input
							placeholder="Pesquise por RE ou nome"
							isSearch colorOfBorder={"#cecece"}
							onChange={e => handleSearch(e.target.value)}
							containerStyle={{ maxWidth: '265px' }}
						/>
							// <SearchContainer>
							// 	<Input placeholder="Pesquise por RE ou nome" width={300} onChange={e => handleSearch(e.target.value)} />
							// 	<AiOutlineSearch style={{ position: 'absolute', right: 10 }} />
							// </SearchContainer>
						}
					</div>
				</SettingsContainer>}

			{isPlacesLoading && <Loading />}
			{showNoPlaceMessage && <EmptyListMessage texto="Nenhum local disponível" />}

			{data && data.map((item, index) =>
				<section className="relative w-full">
					{entriesToShow[index]!.length > 0 &&
						<header className="bg-[#eee] flex flex-col items-center justify-center py-2.5 sticky -top-[17px] w-full min-h-10 min-[800px]:flex-row min-[800px]:gap-[7px] min-[800px]:h-10">
							{/* Desktop */}
							<div className="hidden min-[800px]:flex items-center gap-[7px]">
								<Title>{'Turno: '}</Title>
								<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.turno}</Text>
								<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]"> | </Text>
								<Title>{'Cargo: '}</Title>
								<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.cargo}</Text>
								<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]"> | </Text>
								<Title className="!text-[#4C7AFB]">{'Entrada: '}</Title>
								<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.entrada}</Text>
								<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]"> | </Text>
								<Title className="!text-[#47CC64]">{'S. Ref: '}</Title>
								<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.saidaRefeicao}</Text>
								<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]"> | </Text>
								<Title className="!text-[#e07a5f]">{'R. Ref: '}</Title>
								<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.retornoRefeicao}</Text>
								<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]"> | </Text>
								<Title className="!text-[#ffa62b]">{'Saida: '}</Title>
								<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.saida}</Text>
							</div>

							{/* Mobile */}
							<div className="flex min-[800px]:hidden flex-col w-full items-stretch">
								<div className="flex items-center w-full">
									<div className="flex-1 flex justify-end items-center pr-2 gap-[7px]">
										<Title>{'Turno: '}</Title>
										<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.turno}</Text>
									</div>
									<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">|</Text>
									<div className="flex-1 flex justify-start items-center pl-2 gap-[7px]">
										<Title>{'Cargo: '}</Title>
										<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.cargo}</Text>
									</div>
								</div>

								{/* >= 800px */}
								<div className="hidden min-[500px]:flex items-center w-full">
									<div className="flex-1 flex justify-end items-center pr-2 gap-[7px]">
										<Title className="!text-[#4C7AFB]">{'Entrada: '}</Title>
										<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.entrada}</Text>
										<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">|</Text>
										<Title className="!text-[#47CC64]">{'S. Ref: '}</Title>
										<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.saidaRefeicao}</Text>
									</div>
									<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">|</Text>
									<div className="flex-1 flex justify-start items-center pl-2 gap-[7px]">
										<Title className="!text-[#e07a5f]">{'R. Ref: '}</Title>
										<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.retornoRefeicao}</Text>
										<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">|</Text>
										<Title className="!text-[#ffa62b]">{'Saida: '}</Title>
										<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.saida}</Text>
									</div>
								</div>

								{/* >= 500px */}
								<div className="flex min-[500px]:hidden items-center w-full">
									<div className="flex-1 flex justify-end items-center pr-2 gap-[7px]">
										<Title className="!text-[#4C7AFB]">{'Entrada: '}</Title>
										<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.entrada}</Text>
									</div>
									<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">|</Text>
									<div className="flex-1 flex justify-start items-center pl-2 gap-[7px]">
										<Title className="!text-[#47CC64]">{'S. Ref: '}</Title>
										<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.saidaRefeicao}</Text>
									</div>
								</div>
								<div className="flex min-[500px]:hidden items-center w-full">
									<div className="flex-1 flex justify-end items-center pr-2 gap-[7px]">
										<Title className="!text-[#e07a5f]">{'R. Ref: '}</Title>
										<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.retornoRefeicao}</Text>
									</div>
									<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">|</Text>
									<div className="flex-1 flex justify-start items-center pl-2 gap-[7px]">
										<Title className="!text-[#ffa62b]">{'Saida: '}</Title>
										<Text className="!text-[1rem] !text-[rgba(0,0,0,.5)]">{item.saida}</Text>
									</div>
								</div>

							</div>
						</header>
					}

					<ul className="hidden min-[800px]:block">
						{entriesToShow[index]!.map(registro => {
							return (
								<EntryItem>
									<EntryCell>
										<Subtitle className="!text-[1rem]">
											RE
										</Subtitle>
										<Text className="!text-[.9rem] !text-[rgba(0,0,0,.5)]">
											{registro.rE}
										</Text>
									</EntryCell>

									<EntryCell>
										<Subtitle className="!text-[1rem]">
											Nome
										</Subtitle>
										<Text className="!text-[.9rem] !text-[rgba(0,0,0,.5)]">
											{registro.nome}
										</Text>
									</EntryCell>

									<EntryCell alignRight>
										<Subtitle className="!text-[1rem] !text-[#4C7AFB]">
											Entrada
										</Subtitle>
										<Text className="!text-[.9rem] !text-[rgba(0,0,0,.5)]">
											{registro.entrada}
										</Text>
									</EntryCell>

									<EntryCell alignRight>
										<Subtitle className="!text-[1rem] !text-[#47CC64]">
											S. Ref
										</Subtitle>
										<Text className="!text-[.9rem] !text-[rgba(0,0,0,.5)]">
											{registro.saidaRefeicao}
										</Text>
									</EntryCell>

									<EntryCell alignRight>
										<Subtitle className="!text-[1rem] !text-[#e07a5f]">
											R. Ref
										</Subtitle>
										<Text className="!text-[.9rem] !text-[rgba(0,0,0,.5)]">
											{registro.retornoRefeicao}
										</Text>
									</EntryCell>

									<EntryCell alignRight>
										<Subtitle className="!text-[1rem] !text-[#FFA62B]">
											Saída
										</Subtitle>
										<Text className="!text-[.9rem] !text-[rgba(0,0,0,.5)]">
											{registro.saida}
										</Text>
									</EntryCell>
								</EntryItem>
							)
						}
						)}

					</ul>
					<div className="flex min-[800px]:hidden flex-col gap-1 p-3">
						{entriesToShow[index]!.map(registro => (
							<CardRegistroMobile key={registro.rE} data={registro} />
						))}
					</div>
				</section>
			)}

			{isListLoading && <Loading />}

			{showNoDataMessage && <EmptyListMessage texto="Nenhum dado disponível com esses parâmetros" />}
		</Container>
	)
}

export default Ponto;